import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useStoreState } from 'pullstate';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AppStore } from '../../stores/AppStore.js';

export default function MenuPeopleBuilder() {
    const employees = useStoreState(AppStore, s => s.employees)
    const user = useStoreState(AppStore, s => s.user);
    const [anchorEl, setAnchorEl] = useState(null)
    const [isAdmin, setIsAdmin] = useState({})
    const [isHRAdmin, setIsHRAdmin] = useState({})
    const [isSomeoneCoach, setIsSomeoneCoach] = useState(false)
    const open = Boolean(anchorEl)
    const [anchorElReports, setAnchorElReports] = useState(null)
    const openReports = Boolean(anchorElReports);

    useEffect(() => {
        const checkIfIsCoach = () => {
            if (!employees?.length) return;

            employees.forEach(employee => {
                if (employee?.coach === user?.full_name) {
                    setIsSomeoneCoach(true)
                    return
                }
            })
        }

        checkIfIsCoach()

    }, [user, employees]);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null)
    };
    const handleClickReports = (event) => {
        setAnchorElReports(event.currentTarget)
    }
    const handleCloseReports = () => {
        setAnchorEl(null)
        setAnchorElReports(null)
    }

    const handleFilterType = (type) => {
        // setFilterType(type)
        AppStore.update(s => { s.pbFilterType = type })
        localStorage.removeItem('playerIdClickedPB');
        setAnchorEl(null)
    }

    React.useEffect(() => {
        setIsAdmin(user?.is_lifecycle_admin)
        setIsHRAdmin(user?.is_hr_admin)
    }, [])

    return (
        <div>
            <Button
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                sx={{ color: "inherit" }}
            >
                People Builder
                <ArrowDropDownIcon />
            </Button>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                <MenuItem
                    component={Link}
                    to={`/personal-people-builder/${user?.id}`}
                    onClick={() => handleFilterType('personal')}
                >
                    Personal Goals
                </MenuItem>
                {isSomeoneCoach && (
                    <MenuItem
                        component={Link}
                        to={`/team-people-builder/${user?.id}`}
                        onClick={() => handleFilterType('team')}
                    >
                        Player Goals
                    </MenuItem>
                )}
                {isSomeoneCoach && (
                    <MenuItem
                        component={Link}
                        to={`/department-people-builder/`}
                        onClick={() => handleFilterType('all')}
                    >
                        Department Goals
                    </MenuItem>
                )}
                {(isAdmin || isHRAdmin) && (
                    <MenuItem
                        component={Link}
                        to={`/company-people-builder/1`}
                        onClick={() => handleFilterType('all')}
                    >
                        Company Goals
                    </MenuItem>
                )}
                {(isAdmin || isHRAdmin) && <Divider />}
                {(isAdmin || isHRAdmin) && (
                    <MenuItem
                        id="demo-positioned-button"
                        aria-controls={openReports ? 'demo-positioned-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={openReports ? 'true' : undefined}
                        // onMouseEnter={handleClickReports}
                        onClick={handleClickReports}
                    >
                        <ListItemText>Reports</ListItemText>
                        <ListItemIcon>
                            {openReports ? (
                                <KeyboardArrowRightIcon fontSize="small" />
                            ) : (
                                <KeyboardArrowDownIcon fontSize="small" />
                            )}
                        </ListItemIcon>
                    </MenuItem>
                )}
            </Menu>
            <Menu
                id="demo-positioned-menu"
                aria-labelledby="demo-positioned-button"
                anchorEl={anchorElReports}
                open={openReports}
                onClose={handleCloseReports}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <MenuItem sx={{ height: '1.75rem' }} component={Link} onClick={handleCloseReports} to="/recent-goals">Recent goals</MenuItem>
                <MenuItem sx={{ height: '1.75rem' }} component={Link} onClick={handleCloseReports} to="/clifton-strengths">Clifton Strengths</MenuItem>
            </Menu>
        </div>
    );
}